import React from 'react';
import { typography } from '@/design-system/tokens/typography';

interface DayBadgeProps {
  day: string | number;
  label?: string;
  position?: 'top' | 'bottom';
  showLabel?: boolean;
}

const DayBadge: React.FC<DayBadgeProps> = ({
  day,
  label = 'day',
  position = 'top',
  showLabel = true,
}) => {
  const positionClass = position === 'bottom' ? 'bottom-0' : 'top-0';

  return (
    <>
      <div
        className={`absolute -left-4 ${positionClass} w-8 h-8 bg-black flex justify-center items-center text-white rounded-full text-xs font-semibold text-[12px] leading-[100%] tracking-[0%] text-center`}
      >
        {day}
      </div>
      {showLabel && (
        <div
          className={`absolute -left-12 h-8 ${positionClass} text-black font-semibold flex items-center capitalize`}
          style={{
            fontSize: typography.size.sm, // 14px
            fontFamily: typography.fonts.primary,
          }}
        >
          {label}
        </div>
      )}
    </>
  );
};

export default DayBadge;
